export const environment = {
  production: true,
  apiPrefix: 'https://qcloud2.crg.eu/',
  name: 'prod'
};
